import { usePlayerState, useGameState, useStore, useDeviceId } from '@/engine/store';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { TechView } from '@/components/tech/TechView';
import { GameNotStarted } from '@/components/shared_ui/GameNotStarted';
import { OperatorView } from '@/components/operator/OperatorView';

export const Route = createFileRoute('/game')({
	component: RouteComponent,
});

function RouteComponent() {
	return <GameView />;
}

function GameView() {
	const player = usePlayerState();
	const deviceId = useDeviceId();
	const gameState = useGameState();
	const state = useStore.getState();

	if (!gameState) return null;
	if (gameState.status === 'open') return <GameNotStarted />;
	if (!gameState.members.find((m) => m.deviceId == deviceId)) {
		state.unsetPlayerState();
		throw redirect({ to: '/set-player' });
	}

	return (
		<section className="flex h-screen w-screen items-center justify-center">
			{player.isOperator && <OperatorView />}
			{player.isTechTeam && <TechView />}
		</section>
	);
}

export type TeamData = {
	name: string;
	score: number;
};
